module.exports = __webpack_public_path__ + "static/media/down_icon.974ef75f.svg";